<script setup>
import { useGlobalStore } from '@stores/global.js'
import Modal from '@components/global/modals/layouts/Default.vue'
import Footer from '@components/global/footer.vue'
import Header from '@components/global/header.vue'

const global = useGlobalStore()
</script>

<template>
	<Transition name="fade" :duration="300">
		<Modal v-if="global.modal?.name" :key="global.modal.name" />
	</Transition>
	<Header />
	<router-view v-slot="{ Component, route }">
		<component :is="Component" :key="route.path" />
	</router-view>
	<Footer />
</template>
